import { Component, Input, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { AppConfigService } from "src/app/services/app-config.service";
import { ExtractionService } from "src/app/shared/services/extraction.service";
import { Subject, takeUntil } from "rxjs";
import { CommonModule } from "@angular/common";
import { SalesforceTagComponent } from "src/app/shared/components/salesforce-tag/salesforce-tag.component";
import { ComparisonNormalizer } from "src/app/shared/utils/comparison-normalizer.util";

@Component({
    selector: "app-mmp-sub-header",
    templateUrl: "./mmp-sub-header.component.html",
    styleUrls: ["./mmp-sub-header.component.scss"],
    standalone: true,
    imports: [ CommonModule, SalesforceTagComponent],
})
export class MmpSubHeaderComponent implements OnInit, OnDestroy {
  studentInformation: any;
  studentName: string = "";
  studentCourse: string = "";
  studentUniversity: string = "";
  studentId: string = "";
  studentYear: string = "";
  salesFlagTitle: string =
    "All data in this section is sourced from Salesforce";
  ComparisonNormalizer = ComparisonNormalizer;

  private readonly destroy$ = new Subject<void>();

  @Input() hideSubheader!: boolean;
  @Input() allCombineIds: string[] = [];
  @Input() currentIndex: number = 0;
  @Input() originPage: string = "";

  constructor(
    private readonly router: Router,
    private readonly envService: AppConfigService,
    private readonly extractionService: ExtractionService,
  ) {}

  ngOnInit(): void {
    this.extractionService.studentDetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data) {
          this.studentInformation = data;
          this.studentName = this.studentInformation.name;
          this.studentCourse = this.studentInformation.program;
          this.studentUniversity = this.studentInformation.institution_name;
          this.studentId = this.studentInformation.student_id;
          if (
            ComparisonNormalizer.string(this.envService.university) === "cu"
          ) {
            this.studentYear = "Fall 2025";
          } else if (
            ComparisonNormalizer.string(this.envService.university) === "walden"
          ) {
            this.studentYear = this.studentInformation.start_date;
          }
        }
      });
  }

  onBackClick(): void {
    if (ComparisonNormalizer.string(this.originPage) === "upload") {
      this.router.navigate(["/user-transcripts"]);
    } else {
      this.router.navigate(["/evaluator-dashboard"]);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
